"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.badRandomString = exports.random = exports.roundHalf = exports.roundNumber = exports.getIntersection = exports.contains = exports.clamp01 = exports.clamp = void 0;
function clamp(val, min = undefined, max = undefined, cycle = false) {
    if (min != null && val < min) {
        return (max != null && cycle) ? max : min;
    }
    if (max != null && val > max) {
        return (min != null && cycle) ? min : max;
    }
    return val;
}
exports.clamp = clamp;
function clamp01(val) {
    return clamp(val, 0, 1, false);
}
exports.clamp01 = clamp01;
function contains(val, from, to) {
    const s = Math.min(from, to);
    const e = Math.max(from, to);
    return val >= s && val <= e;
}
exports.contains = contains;
function getIntersection(v1, v2, r1, r2) {
    const v = [v1, v2].sort();
    const r = [r1, r2].sort();
    const res = (v[0] >= r[0] && v[0] <= r[1])
        || (v[1] >= r[0] && v[1] <= r[1])
        || (r[0] >= v[0] && r[0] <= v[1])
        || (r[1] >= v[0] && r[1] <= v[1]);
    if (!res) {
        return false;
    }
    return {
        ranges: [v, r],
        merged: {
            s: Math.min(v[0], r[0]),
            e: Math.max(v[1], r[1]),
        },
    };
}
exports.getIntersection = getIntersection;
function roundNumber(val, signs = 2, mode) {
    const k = 10 ** signs;
    let v = (val + Number.EPSILON) * k;
    switch (mode) {
        case 'floor':
            v = Math.floor(v);
            break;
        case 'ceil':
            v = Math.ceil(v);
            break;
        default:
            v = Math.round(v);
            break;
    }
    return v / k;
}
exports.roundNumber = roundNumber;
function roundHalf(num) {
    return Math.round(num * 2) / 2;
}
exports.roundHalf = roundHalf;
function random(min = 0, max = 1, trunc = true) {
    const r = Math.random();
    const res = min + r * (max - min);
    return trunc ? Math.trunc(res) : res;
}
exports.random = random;
function badRandomString(length = 12) {
    const limitedLength = clamp(length, 0, 12);
    const result = Math.random().toString(26).slice(2, 2 + limitedLength);
    // this happens when random number is rounded so no last char
    if (result.length < limitedLength) {
        return result + new Array(limitedLength - result.length).fill('0').join('');
    }
    return result;
}
exports.badRandomString = badRandomString;
//# sourceMappingURL=calc.js.map